<template>
  <div class="text-13 h-6 flex items-center">
    <div class="text-13 h-6 flex items-center">{{ $t('evaluate_editor.data-mapper-excel-to-datatable') }}</div>
  </div>
</template>

<script>
export default {
  name: 'DataMapperExcelToDataTableOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  // computed: {
  //   title() {
  //     if (this.item?.payload?.title) {
  //       return ` - ${this.item?.payload?.title}`;
  //     }
  //     return '';
  //   },
  // },
};
</script>
